import styled from '@emotion/styled';
import { colors, MagicStarBig, Text } from '@innovationdepartment/proxima-ui';
import { useLocation, useNavigate } from 'react-router';
import LoggedInAsBrand from 'ui/LoggedInAsBrand';

const Header = styled.div`
  width: 100%;
  height: 68px;
  display: flex;
  padding: 0px 16px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const LeftHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1;

  & path {
    fill: ${colors.white};
  }
`;

const BrandingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const NavTabs = styled.div`
  display: flex;
  gap: 8px;
`;

const NavTab = styled.button<{ isActive: boolean }>`
  padding: 8px 16px;
  border: none;
  background: ${props => (props.isActive ? colors.neutral20 : 'transparent')};
  color: ${props => (props.isActive ? colors.neutral100 : colors.white)};
  cursor: pointer;
  font-size: 14px;
  font-weight: ${props => (props.isActive ? 600 : 400)};
  transition: all 0.2s;
  border-radius: 4px;

  &:hover {
    background: ${colors.neutral20};
    color: ${colors.neutral100};
  }
`;

const NavigationHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const selectedView = location.pathname.includes('/brand-tags') ? 'brand-tags' : 'brands';

  const handleViewChange = (view: string) => {
    navigate(`/${view}`);
  };

  return (
    <Header>
      <LeftHeaderContainer>
        <BrandingContainer>
          <MagicStarBig />
          <Text color="offWhite" variant="h5">
            Nova
          </Text>
        </BrandingContainer>
        <NavTabs>
          <NavTab isActive={selectedView === 'brands'} onClick={() => handleViewChange('brands')}>
            Brands
          </NavTab>
          <NavTab
            isActive={selectedView === 'brand-tags'}
            onClick={() => handleViewChange('brand-tags')}
          >
            Brand Tags
          </NavTab>
        </NavTabs>
      </LeftHeaderContainer>
      <LoggedInAsBrand />
    </Header>
  );
};

export default NavigationHeader;
